import * as React from "react";
import ZqProvider from "zq-ui-v3/ZqProvider";
import { Router } from "react-router-dom";
// import menus from "./routes/menus";
import { createBrowserHistory } from "history";
import Routes from "./routes";
import MenuIcon from "@material-ui/icons/Menu";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import { callApiByPath, setupAxios } from "./api/axios";
import ZqAdminProvider from "zq-ui-admin/ZqAdminProvider";
import Login from "./pages/Login";
import cookie from "react-cookies";
import { getAllInfo } from "./utils/device";
import { useDispatch, useSelector } from "react-redux";
import { updateProfile } from "./redux/actions";
import MainLayout from "./layout/MainLayout";
import { delay, genUUID, isNull } from "zq-ui-v3/utils/utils";
import { inWhiteList } from "./routes/whiteList";
import "./App.css";

export const history = createBrowserHistory();

const iconMap: {
  [key: string]: React.FC<SvgIconProps>;
} = { list: MenuIcon };
const App: React.FC = () => {
  const [openLogin, setOpenLogin] = React.useState<boolean>(false);
  const dispatch = useDispatch();
  const menus = useSelector((state: any) => state.profile?.menuTree);

  const data = useSelector((state: any) => state.websocket);
  const { status, type, content } = data || {};
  console.log(status, type, content);

  setupAxios(history, setOpenLogin);
  React.useEffect(() => {
    (async () => {
      try {
        let deviceId = localStorage.getItem("deviceId");
        if (!deviceId) {
          deviceId = cookie.load("deviceId");
        }
        if (!deviceId) {
          deviceId = genUUID();
          const re: any = await callApiByPath("post", "/common/Device/save", {
            _id: deviceId,
            ...getAllInfo(window.navigator.userAgent),
          });
          localStorage.setItem("deviceId", re._id);
          cookie.save("deviceId", re._id);
        }
        window.onerror = async function (msg, url, line, col, error, ...others) {
          // 直接将错误打印到控制台
          if (isNull(error) && line === 0 && col === 0) return;
          console.log(msg, url, line, col, error?.stack, ...others);
          // 方便在未打开控制台的时候，记录错误对象
          try {
            await callApiByPath("post", "/common/JsError/save", {
              _id: genUUID(),
              deviceId,
              msg,
              url,
              line,
              col,
              error: error?.stack,
              others,
            });
          } catch (e) {
            console.log(e);
          }
        };
        if (!inWhiteList(history.location.pathname)) {
          const profile = await callApiByPath("get", "/account/User/myInfo");
          dispatch(updateProfile(profile));
          // dispatch(socketClose());
          // dispatch(socketConnect());
        }
      } catch (e) {
        console.error(e);
      }
      await delay(1600);
      document.getElementById("loading").style.opacity = "0";
      await delay(800);
      document.getElementById("loading").style.display = "none";
      // websocket 链接
    })();
    return () => {};
  }, []);

  return (
    <ZqAdminProvider openLogin={openLogin} setOpenLogin={setOpenLogin}>
      <Login
        history={history}
        {...{
          open: openLogin || !menus?.length,
          onClose: () => setOpenLogin(false),
          isDialog: true,
          dialogProps: { open: openLogin, hideCloseBtn: true, hideFullBtn: true },
        }}
      />
      <ZqProvider name="金融监管报数系统" iconMap={iconMap} menuList={menus}>
        {menus?.length > 0 && (
          <MainLayout history={history}>
            <Router history={history}>
              <Routes />
            </Router>
          </MainLayout>
        )}
      </ZqProvider>
    </ZqAdminProvider>
  );
};
export default App;
